// extracted by mini-css-extract-plugin
module.exports = {"tile":"CategoryTile_tile__3mCku","tile__image":"CategoryTile_tile__image__2hMvr","tile__name":"CategoryTile_tile__name__4ediH"};